import React from 'react';
import Head from 'next/head';

import useTranslation from 'hooks/use-translation';

import { getCityToDisplay } from 'shared/helpers/address';
import { useMetaInfo } from './use-meta-info';

import Meta from './meta';

// default title values
/* eslint-disable */
const PageTitles = {
  about: 'About Us | dutchie',
  blog: 'dutchie | Blog',
  cities: 'Dispensaries by city - US & Canada | dutchie',
  city: '{{city}} {{state}} Dispensaries - order online, delivery or pickup | Dutchie',
  default: 'dutchie | Order cannabis online for pickup or delivery',
  dispensary: '{{dispensaryName}} - Cannabis Dispensary, {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensaryProduct: '{{productName}} | {{dispensaryName}} {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensarySpecials: '{{dispensaryName}} Dispensary Deals {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensaryBrands: '{{dispensaryName}} Cannabis Brands Sold | Dutchie',
  dispensaryBrand: '{{brandName}} - {{dispensaryName}}, {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensaryInfo: '{{dispensaryName}} Hours & Info - {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensaryProductCategories:
    '{{dispensaryName}} Products - {{dispensaryCity}} {{dispensaryState}} Dispensary | Dutchie',
  dispensaryProductCategory:
    '{{productCategory}} at {{dispensaryName}} Dispensary {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  dispensaryProductSubcategory:
    '{{productSubcategory}} at {{dispensaryName}} Dispensary {{dispensaryCity}} {{dispensaryState}} | Dutchie',
  careers: 'Careers | dutchie',
  contact: 'Contact Us | dutchie',
  help: 'Get Help | dutchie',
  home: 'Dutchie | Order cannabis online from dispensaries near me',
  isolatedCheckout: '{{dispensaryName}} Checkout',
  news: 'News | dutchie',
  privacy: 'Privacy Policy | dutchie',
  dispoTerms: 'Dispensary Terms and Conditions | dutchie',
  terms: 'Terms of Service | dutchie',
  accessibility: 'Accessibility | dutchie',
  messaging: 'Order Messaging',
  curbsideArrivals: 'Curbside Arrival',
  plus: 'Dutchie Plus | Cannabis E-commerce for the Enterprise',
  whoops: '404 | Page Not Found | Dutchie.com',
};
/* eslint-enable */

export function useTitle(variant, location) {
  const { t } = useTranslation();
  const metaInfo = useMetaInfo();

  if (!PageTitles[variant]) {
    variant = `default`;
  }
  const data = {
    defaultValue: PageTitles[variant],
    ...metaInfo,
  };

  if (location) {
    data.city = getCityToDisplay(location);
    data.state = location.state;
  }

  /* i18next-extract-disable-next-line */
  return t(`head.title.${variant}`, data);
}

export default function PageTitle(props) {
  const { variant, location } = props;
  const title = useTitle(variant, location);

  return (
    <React.Fragment>
      <Head>
        <title key='title'>{title}</title>
      </Head>
      <Meta property='og:title' content={title} />
    </React.Fragment>
  );
}
